module.exports = __webpack_public_path__ + "img/img_giveaway_samsung.a94c3490.png";